import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { rootStateSelector } from '../store';

export const applicationSelector = createDraftSafeSelector(rootStateSelector, (state) => state.application);

export const stepSelector = createDraftSafeSelector(applicationSelector, (state) => state.step);

export const iShowSidebarSelector = createDraftSafeSelector(applicationSelector, (state) => state.isShowSidebar);
